import { i18n } from "i18n/index";
import { addComma } from "utils/Format";
import { getTokenInfo } from "utils/getters";
import Badge from "assets/image/badge.png";
import store from "store";
import cn from "classnames";
import { setRefresh } from "store/reducers/bestPriceCoins";
const isRefresh = () => store.getState().bestPriceCoins.isRefresh;
setTimeout(() => {
  store.dispatch(setRefresh(false));
}, 1000);
export const LIVE_PRICE_DESKTOP_COLUMNS_TOMAN = [
  {
    Header: i18n.t("Currency name"),
    accessor: (values: any) => {
      return values;
    },
    minWidth: 100,
    width: 250,
    Cell: (cellProps: any) => {
      const { localeName, logoUrl64px, symbol } = cellProps.value;
      return (
        <div className="d-flex  flex-row-reverse align-items-center justify-content-between">
          <div className="d-flex justify-content-around  w-100">
            <span className="text-secondary-three-light fw-normal fs-6">
              {localeName}
            </span>
            <span className="">{symbol}</span>
          </div>
          <img src={logoUrl64px} className="coin-logo" />
        </div>
      );
    },
  },
  {
    Header: () => (
      <div className="text-center">{i18n.t("Last price (Tomans)")}</div>
    ),
    accessor: "bestBuy",
    minWidth: 100,
    width: 250,

    Cell: (cellProps: any) => (
      <span className={cn("fw-normal text-secondary-seven-light")}>
        {addComma(Number(cellProps.value))}
      </span>
    ),
  },
  {
    Header: () => <div className="text-center">{i18n.t("Trading volume")}</div>,
    accessor: "vol24Base",
    minWidth: 100,
    width: 250,

    Cell: (cellProps: any) => (
      <span className={"fw-normal text-secondary-seven-light"}>
        {addComma(Number(cellProps.value))}
      </span>
    ),
  },
  {
    Header: () => <div className="text-center">{i18n.t("Changes rate")}</div>,
    accessor: "change24Percentage",
    minWidth: 100,
    width: 250,

    Cell: (cellProps: any) => (
      <div
        className={cn(
          "position-relative d-flex justify-content-center",
          cellProps.value > 0 ? "text-success-light" : "text-danger-light"
        )}
      >
        {cellProps.value < 0 ? (
          <span className="style-ltr">{Number(cellProps.value)}</span>
        ) : (
          <span className="style-ltr">{`+${Number(cellProps.value)}`}</span>
        )}
      </div>
    ),
  },
];
export const LIVE_PRICE_DESKTOP_COLUMNS_TETHER = [
  {
    Header: i18n.t("Currency name"),
    accessor: (values: any) => {
      return values;
    },
    minWidth: 100,
    width: 250,

    Cell: (cellProps: any) => {
      const { localeName, logoUrl64px, symbol } = cellProps.value;
      return (
        <div className="d-flex flex-row-reverse align-items-center justify-content-between">
          <div className="d-flex justify-content-around  w-100">
            <span className="text-secondary-three-light fw-normal fs-6">
              {localeName}
            </span>
            <span className="">{symbol}</span>
          </div>
          <img src={logoUrl64px} className="coin-logo" />
        </div>
      );
    },
  },
  {
    Header: () => (
      <div className="text-center">{i18n.t("Last price (Tether)")}</div>
    ),
    accessor: "bestBuy",
    minWidth: 100,
    width: 250,

    Cell: (cellProps: any) => (
      <span className={"fw-normal text-secondary-seven-light"}>
        {addComma(Number(cellProps.value))}
      </span>
    ),
  },
  {
    Header: () => <div className="text-center">{i18n.t("Trading volume")}</div>,
    accessor: "vol24Base",
    minWidth: 100,
    width: 250,

    Cell: (cellProps: any) => (
      <span className={"fw-normal text-secondary-seven-light"}>
        {addComma(Number(cellProps.value))}
      </span>
    ),
  },
  {
    Header: () => <div className="text-center">{i18n.t("Changes rate")}</div>,
    accessor: "change24Percentage",
    minWidth: 100,
    width: 250,
    Cell: (cellProps: any) => (
      <div
        className={cn(
          "d-flex justify-content-center",
          cellProps.value > 0 ? "text-success-light" : "text-danger-light"
        )}
      >
        {cellProps.value < 0 ? (
          <span className="style-ltr">{Number(cellProps.value)}</span>
        ) : (
          <span className="style-ltr">{`+${Number(cellProps.value)}`}</span>
        )}
      </div>
    ),
  },
];
export const LIVE_PRICE_MOBILE_COLUMNS = [
  {
    Header: i18n.t("Currency name"),
    accessor: (values: any) => {
      return values;
    },
    minWidth: 80,

    Cell: (cellProps: any) => {
      const { localeName, logoUrl64px, symbol } = cellProps.value;
      return (
        <div className="d-flex flex-row-reverse  align-items-center justify-content-around pe-1">
          <div className="d-flex flex-column-reverse flex-lg-row justify-content-around align-items-center">
            <span className="text-secondary-three-light fs-xs fw-normal fs-6">
              {localeName}
            </span>
            <span className="fs-xs">{symbol}</span>
          </div>
          <img src={logoUrl64px} width={25} />
        </div>
      );
    },
  },
  {
    Header: () => <div className="text-center">{i18n.t("Last price")}</div>,

    accessor: "bestBuy",
    Cell: (cellProps: any) => (
      <span className={"fw-normal text-secondary-seven-light fs-8"}>
        {addComma(Number(cellProps.value))}
      </span>
    ),
  },
  {
    Header: () => <div className="text-center">{i18n.t("Changes")}</div>,
    accessor: "change24Percentage",
    Cell: (cellProps: any) => (
      <div
        className={cn(
          "d-flex justify-content-center",
          cellProps.value > 0 ? "text-success-light" : "text-danger-light"
        )}
      >
        {cellProps.value < 0 ? (
          <span className="style-ltr">{Number(cellProps.value)}</span>
        ) : (
          <span className="style-ltr">{`+${Number(cellProps.value)}`}</span>
        )}
      </div>
    ),
  },
];

export const LIVE_PRICE_DESKTOP_COLUMNS_ALL_COIN = [
  {
    Header: i18n.t("Currency name"),
    accessor: (values: any) => {
      return values;
    },
    // Filter: SelectColumnFilter,
    filter: "includes",
    minWidth: 100,
    width: 250,
    Cell: (cellProps: any) => {
      const { localeName, logoUrl64px, symbol } = cellProps.value;
      return (
        <>
          <div className="d-flex align-items-center flex-row-reverse justify-content-between">
            <div className="d-flex justify-content-around column-in-sm w-100">
              <span className="text-secondary-three-light fw-normal fs-6">
                {localeName}
              </span>
              <span className="">{symbol}</span>
            </div>
            <img src={logoUrl64px} className="coin-logo" />
          </div>
        </>
      );
    },
  },
  {
    Header: () => <div className="text-center">{i18n.t("Last price ")}</div>,
    accessor: "bestBuy",
    minWidth: 100,
    width: 250,
    Cell: (cellProps: any) => (
      <span className={"fw-normal text-secondary-seven-light"}>
        {addComma(Number(cellProps.value))}
      </span>
    ),
  },
  {
    Header: () => (
      <div className="text-center"> {i18n.t("Trading volume")}</div>
    ),
    accessor: "vol24Base",
    minWidth: 100,
    width: 250,
    Cell: (cellProps: any) => (
      <span className={"fw-normal text-secondary-seven-light"}>
        {addComma(Number(cellProps.value))}
      </span>
    ),
  },
  {
    Header: () => <div className="text-center"> {i18n.t("Changes rate")}</div>,
    accessor: "change24Percentage",
    minWidth: 100,
    width: 250,
    Cell: (cellProps: any) => (
      <div
        className={cn(
          "position-relative d-flex justify-content-center",
          cellProps.value > 0 ? "text-success-light" : "text-danger-light"
        )}
      >
        {cellProps.value < 0 ? (
          <span className="style-ltr">{Number(cellProps.value)}</span>
        ) : (
          <span className="style-ltr">{`+${Number(cellProps.value)}`}</span>
        )}
      </div>
    ),
  },
  {
    Header: () => <div className="text-center"> {i18n.t("lowest price")}</div>,
    accessor: "lastPrice",
    minWidth: 100,
    width: 250,
    Cell: (cellProps: any) => (
      <span className={"fw-normal text-secondary-seven-light"}>
        {addComma(Number(cellProps.value))}
      </span>
    ),
  },
  {
    Header: () => <div className="text-center"> {i18n.t("highest price")}</div>,
    accessor: "bestSell",
    minWidth: 100,
    width: 250,
    Cell: (cellProps: any) => (
      <span className={"fw-normal text-secondary-seven-light"}>
        {addComma(Number(cellProps.value))}
      </span>
    ),
  },
];

export const TRADING_FEES = [
  {
    Header: i18n.t("Trading volume of the last 30 days (Tomans)"),
    accessor: "col1",
    minWidth: 50,
  },
  {
    Header: i18n.t("Customer Fee"),
    accessor: "col2",
    minWidth: 30,
  },
  {
    Header: i18n.t("Customizable fee"),
    accessor: "col3",
    minWidth: 30,
  },
  {
    Header: i18n.t("Level of loyalty"),
    accessor: (value: any) => (
      <div className="text-nowrap">
        <img src={Badge} width={32} />
        <span className="px-2">{value.col4}</span>
      </div>
    ),
    minWidth: 10,
  },
];

export const RIALS_FEES_DESKTOP_COLUMNS = [
  {
    Header: i18n.t("Destination account"),
    accessor: "col1",
    minWidth: 200,
  },
  {
    Header: i18n.t("Withdrawal request time"),
    accessor: "col2",
    minWidth: 200,
  },
  {
    Header: i18n.t("Settlement time"),
    accessor: "col3",
    minWidth: 200,
  },
];
export const RIALS_FEES_MOBILE_COLUMNS = [
  {
    Header: i18n.t("Withdrawal request time"),
    accessor: "col2",
    minWidth: 100,
  },
  {
    Header: i18n.t("Settlement time"),
    accessor: "col3",
    minWidth: 100,
  },
];
export const WITHDRAWAL_FEES = [
  {
    Header: i18n.t("cryptocurrency"),
    accessor: (values: any) => {
      const { token } = values;
      return token;
    },
    Cell: (props: any) => {
      return (
        <div className="d-flex align-items-center">
          <img width={30} src={getTokenInfo(props.value, "logoUrl64px")} />
          <div className="d-flex flex-column-reverse flex-lg-row justify-content-around align-items-center w-50">
            <span className="px-3 text-nowrap">
              {getTokenInfo(props.value, "localeName")}
            </span>
            <span className="">{props.value}</span>
          </div>
        </div>
      );
    },
    minWidth: 30,
    width: 10,
  },
  {
    Header: i18n.t("Withdrawal fee"),
    accessor: (values: any) => {
      let fee = "";
      values.blockchains.map((item: any) => (fee = item.fee));
      return fee;
    },
    Cell: (props: any) => {
      return (
        <div>
          <span>{props.fee}</span>
          <span className="text-nowrap px-3">{props.value}</span>
        </div>
      );
    },
    minWidth: 30,
    width: 10,
  },
  {
    Header: i18n.t("Minimum Withdrawal"),
    accessor: (values: any) => {
      let minAmount = "";
      values.blockchains.map((item: any) => (minAmount = item.minAmount));
      return minAmount;
    },
    Cell: (props: any) => {
      return (
        <div>
          <span>{props.minAmount}</span>
          <span className="px-3">{props.value}</span>
        </div>
      );
    },
    minWidth: 30,
    width: 10,
  },
];
